import iconsPng from '@/assets/img/png/icons';
import CustomButton from '@/components/atoms/CustomButton';
import ModalContainer from '@/components/molecules/ModalContainer';
import { text } from '@/theme/colors/palettes';
import { Center, HStack, Image, Text, VStack } from '@chakra-ui/react';
import React from 'react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  isLoading: boolean;
}

const GoalCompletionConfirmationModal = ({ isOpen, onClose, onSubmit, isLoading }: Props) => {
  return (
    <ModalContainer
      isBlur={false}
      isOpen={isOpen}
      onClose={onClose}
      width={'40%'}
      backgroundColor="background.lightBlue"
      footerContent={
        <HStack justifyContent={'center'} width={'100%'} paddingBottom={'20px'}>
          <CustomButton
            label={'Confirm'}
            labelColor="extra.white"
            labelHoverColor={'extra.white'}
            backgroundColor={'primary.500'}
            labelStyle={{ fontSize: '16px' }}
            onClick={onSubmit}
            style={{ minWidth: '150px' }}
            height={'60px'}
            isLoading={isLoading}
            disabled={isLoading}
          />
        </HStack>
      }
    >
      <VStack width={'100%'} height={'100%'} justify="space-between" paddingBottom={'20px'}>
        <Text variant={'loraMedium22'} color={text.darkBlue} marginTop={'24px'}>
          Mark Goal as Complete?
        </Text>

        <Center>
          <Image src={iconsPng.okHand} style={{ height: 100, width: 100 }} />
        </Center>

        <Text variant={'urbanistMedium18'} color={text.mediumBlue} maxWidth={'350px'} marginTop={'20px'}>
          Kudos to keeping up with your goals and moving toward better self!
        </Text>
      </VStack>
    </ModalContainer>
  );
};

export default GoalCompletionConfirmationModal;
